'use strict';

const jQuery = require('jquery');

const Tree = require('./../../../services/tree');

const Repository = require('./../repository/TagRepository');

const transformItem = (item, showChildren) => {
  return {
    label: item.keyword,
    more: item.has_children,
    showChildren,
    id: item.uid,
  };
};

const transformItems = (items, showChildren = true) => {
  return items.map((item) => {
    return transformItem(item, showChildren);
  });
};

const getContentRangeData = (contentRange) => {
  let data = /^(.*)-(.*)\/(.*)/.exec(contentRange);

  return {start: parseInt(data[1], 10), end: parseInt(data[2], 10), total: parseInt(data[3], 10)};
};

let currentRangeData = null;

module.exports.create = (config = {}) => {
  let showChildren = config.showChildren !== false;

  return new Promise((resolve) => {
    Repository.findFirstLevel().done((tags, response) => {
      let rangeData = getContentRangeData(response.headers['content-range']);

      currentRangeData = rangeData;

      let $tree = Tree.create({
        items: transformItems(tags, showChildren),
        appendTo: config.appendTo,
        onItemClick: config.onItemClick,
        rootMore: !(rangeData.end === (rangeData.total - 1)),
        maxLevel: !showChildren ? 1 : null,
        onMoreClick: function() {
          return new Promise((resolve) => {
            Repository.findBy({range: `${currentRangeData.end + 1}-${currentRangeData.end + 50}`}).done((children, response) => {
              currentRangeData = getContentRangeData(response.headers['content-range']);
              resolve({
                children: transformItems(children, showChildren),
                more: !(currentRangeData.end === (currentRangeData.total - 1)),
              });
            });
          });
        },
        onShowChildren: function(item) {
          return new Promise((resolve) => {
            Repository.findByParent(item.id).done((children) => {
              resolve({
                children: transformItems(children, showChildren),
                more: false,
              });
            });
          });
        },
      });

      jQuery('body').on('click', function(e) {
        let $target = jQuery(e.target);

        if (!$target.parents('.cloud-tree:first').length && !$target.hasClass('cloud-tree-input')) {
          $tree.addClass('d-none');
        }
      });

      resolve($tree);
    });
  });
};
